document.addEventListener('DOMContentLoaded', function() {
  const headerOffset = 65;
  const productNav = document.querySelector("[data-product-nav]");
  const productNavItem = document.querySelectorAll("[data-product-nav-item]");
  const sections = document.querySelectorAll("[data-product-section]");
  const productSticky = document.querySelector("[data-product-sticky]");
  const productFormSubmit = document.querySelector(".product-form__submit");
  stickyProduct();

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        (rect.top - (headerOffset / 2))  >= 0 &&
        rect.left >= 0 &&
        (rect.bottom + (headerOffset / 2)) <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
  }

  function stickyProduct() {
    if (productFormSubmit && !isInViewport(productFormSubmit)) {
      productSticky.classList.add("show");
    } else {
      productSticky.classList.remove("show");
    }
  }

  const productChooseOptions = document.querySelector("#productChooseOptions");
  const productInfos = document.querySelector("product-info");
  productChooseOptions.addEventListener('click', function() {
    window.scrollTo({top: productInfos.getBoundingClientRect().top, behavior: "smooth"});
  });
  
  document.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (200 < scrollTop) {
      productNav.classList.add("show");
    } else {
      productNav.classList.remove("show");
    }

    if (productFormSubmit && !isInViewport(productFormSubmit)) {
      productSticky.classList.add("show");
    } else {
      productSticky.classList.remove("show");
    }
  });

  productNavItem.forEach(function(item) {
    item.addEventListener("click", function(event) {
      event.preventDefault();
      const productSection = document.querySelector(this.hash);
      const activeItem = document.querySelector("[data-product-nav-item].active");
      if (activeItem) activeItem.classList.remove("active");
      item.classList.add("active");
      const sectionPosition = productSection.getBoundingClientRect().top;
      const offsetPosition = sectionPosition + window.pageYOffset - headerOffset;
      window.scrollTo({top: offsetPosition, behavior: "smooth"});
    });
  });
  window.addEventListener("scroll", navHighlighter);
  
  let ch = false;
  let key = false;
  function navHighlighter() {
    let scrollY = window.pageYOffset || document.documentElement.scrollTop;
    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = (current.getBoundingClientRect().top + scrollY) - headerOffset - 40;
      sectionId = current.getAttribute("id");
      if (
        scrollY > sectionTop &&
        scrollY <= sectionTop + sectionHeight
      ){
        document.querySelector(`[data-product-nav-item][href*="#${sectionId}"]`).classList.add("active");
      } else {
        document.querySelector(`[data-product-nav-item][href*="#${sectionId}"]`).classList.remove("active");
      }
    });

    let scrollLeft = productNav.scrollLeft;
    if (document.querySelector("[data-product-nav-item].active")) {
      let offsetLeft = document.querySelector("[data-product-nav-item].active").offsetLeft;
      let scrollRight = scrollLeft + offsetLeft;
      if (key != false && key != offsetLeft) {
          productNav.scrollTo({top : 0, left : scrollRight - 15, behavior : "smooth"});
      }
      if (ch != false && ch != scrollLeft) {
          productNav.scrollTo({top : 0, left : offsetLeft - 15, behavior : "smooth"});
      }
      ch = scrollLeft;
      key = offsetLeft;
    }
  }
});